import { useLockBodyScroll } from "@uidotdev/usehooks";
import { useState } from "react";

import { setCookie } from "../util/cookies";

import { ReactSVG } from "react-svg";

import logo from "../assets/svg/logo.svg";
import star from "../assets/svg/star.svg";

const AgeGate = ({ setIsGateOpen }) => {
	useLockBodyScroll();

	const [isUnderage, setIsUnderage] = useState(false);

	const yesClickHandler = () => {
		setIsGateOpen(false);
		setCookie("ageGate", "true", 30);
	};

	const noClickHandler = () => {
		setIsUnderage(true);
	};

	return (
		<div className="bg-blue absolute top-0 left-0 z-100 flex min-h-svh w-full flex-col items-center justify-center gap-12 overflow-hidden py-50">
			<ReactSVG src={logo} className="absolute top-0 mt-10 [&_svg]:h-auto [&_svg]:w-30 [&_svg]:md:w-40" />
			{!isUnderage && (
				<>
					<p className="text-center font-serif text-4xl leading-[1.2] text-white uppercase md:text-6xl lg:text-7xl">
						Sei maggiorenne?
					</p>
					<div className="flex gap-6 font-serif text-3xl text-white md:text-4xl lg:text-5xl">
						<button className="bg-red cursor-pointer px-10 py-3 uppercase md:px-14 md:py-5" onClick={noClickHandler}>
							No
						</button>
						<button
							className="bg-light-blue cursor-pointer px-10 py-3 uppercase md:px-14 md:py-5"
							onClick={yesClickHandler}>
							Sì
						</button>
					</div>
				</>
			)}
			{isUnderage && (
				<div className="flex flex-col gap-6 px-8 text-center text-white md:gap-9 lg:gap-12">
					<p className="font-serif text-3xl leading-[1.2] md:text-4xl lg:text-5xl">
						TI ASPETTIAMO QUANDO AVRAI 18&nbsp;ANNI
					</p>
					<p className="text-lg md:text-xl">Ne teniamo una in fresco per te</p>
				</div>
			)}
			<ReactSVG
				src={star}
				className="absolute top-0 left-0 w-5/10 -translate-x-2/5 -translate-y-4/10 md:w-4/10 md:-translate-x-1/2 [&_svg]:h-auto [&_svg]:w-full [&_svg]:fill-white"
			/>
			<ReactSVG
				src={star}
				className="[&_svg]:fill-red absolute right-0 bottom-0 w-5/10 translate-x-4/10 translate-y-[35%] md:w-4/10 md:translate-y-4/10 [&_svg]:h-auto [&_svg]:w-full"
			/>
		</div>
	);
};

export default AgeGate;
